import { render, staticRenderFns } from "./ExtraTable.vue?vue&type=template&id=5ea752fc"
import script from "./ExtraTable.vue?vue&type=script&lang=ts"
export * from "./ExtraTable.vue?vue&type=script&lang=ts"
import style0 from "./ExtraTable.vue?vue&type=style&index=0&id=5ea752fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports